import { atom } from "jotai";

// Menu State Atoms
export const menuOpenAtom = atom(false);
export const isOverlayOpenAtom = atom(false);
export const showContextMenuAtom = atom(false);
export const showSubscriptionMenuAtom = atom(false);
export const overlayContentAtom = atom(null);
export const contextMenuPositionAtom = atom({ x: 0, y: 0 });
export const filtersMenuTemporaryVisibleAtom = atom(false);
